import React from "react";
import { MdStar } from "react-icons/md";
import styles from "./RatingDisplay.module.scss";
import { SaleItemInterface } from "../types/types";
import { useTheme } from "../hooks/useTheme";

interface Props {
  item: SaleItemInterface;
  size?: "small" | "medium" | "large";
  showMyRating?: boolean;
}

export const RatingDisplay: React.FC<Props> = ({
  item,
  size = "medium",
  showMyRating = true,
}) => {
  
  if (!item) return null;

  const avgNum = Number(item.averageRating) || 0;
  const totalNum = Number(item.totalRatings) || 0;
  const hasUserRating = item.ratings && item.ratings.length > 0;
  const myRating = item.ratings?.[0]?.rating;

  const sizes = {
    small: { stars: 16, rating: 24, count: 12 },
    medium: { stars: 20, rating: 36, count: 14 },
    large: { stars: 24, rating: 48, count: 16 },
  };

  const { stars: starSize } = sizes[size];
  const hasRatings = totalNum > 0;
  const displayRating = hasRatings ? (avgNum + 1).toFixed(1) : "0.0";

  return (
    <div className={styles.container}>
      {/* Средний рейтинг */}
      <div className={styles.averageRating}>
        <span
          className={styles.ratingNumber}
          style={{ fontSize: sizes[size].rating }}
        >
          {displayRating}
        </span>

        <div>
          <div className={styles.starsContainer}>
            {[1, 2, 3, 4, 5].map((star) => (
              <MdStar
                key={star}
                size={starSize}
                className={styles.star}
                style={{
                  color: hasRatings
                    ? star <= avgNum + 1
                      ? "#FFD700"
                      : "#ccc"
                    : "#ccc",
                }}
              />
            ))}
          </div>

          <span
            className={styles.countText}
            style={{ fontSize: sizes[size].count }}
          >
            {hasRatings ? `(${item.totalRatings} оц.)` : "(Нет оценок)"}
          </span>
        </div>
      </div>

      {/* Моя оценка */}
      {showMyRating && hasUserRating && myRating !== undefined && (
        <div className={styles.myRating}>
          <span className={styles.myRatingTitle}>Моя оценка</span>
          <div className={styles.starsContainer}>
            {[1, 2, 3, 4, 5].map((star) => (
              <MdStar
                key={star}
                size={starSize - 4}
                className={styles.star}
                style={{
                  color: star <= myRating + 1 ? "#FFD700" : "#ccc",
                }}
              />
            ))}
          </div>
          {item.ratings?.[0]?.comment && (
            <p className={styles.comment}>{item.ratings[0].comment}</p>
          )}
        </div>
      )}
    </div>
  );
};
